import { render } from "./TitlePage.vue?vue&type=template&id=2269e43f&scoped=true"
import script from "./TitlePage.vue?vue&type=script&lang=js"
export * from "./TitlePage.vue?vue&type=script&lang=js"

import "./TitlePage.vue?vue&type=style&index=0&id=2269e43f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2269e43f"]])

export default __exports__